import React from 'react';
import { ArrowLeft } from 'lucide-react';

const PageHeader = ({ 
  title, 
  subtitle,
  actions = null, 
  backButton = false,
  onBack = undefined,
  actionsHidden = false, 
  reserveWidthPx = undefined,
  className = '',
  ...props 
}) => {
  return (
    <div className={`flex justify-between items-start mb-6 ${className}`} {...props}>
      <div className="min-w-0 flex-1">
        {backButton && (
          <button
            onClick={onBack}
            className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-2"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back
          </button>
        )}
        <h1 className="text-2xl font-bold text-gray-900 truncate">{title}</h1>
        {subtitle && (
          <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
        )}
      </div>
      
      {(actions || actionsHidden) && (
        <div
          className={`flex items-center gap-3 ml-6 flex-shrink-0 ${actionsHidden ? 'invisible' : ''}`}
          style={reserveWidthPx ? { minWidth: reserveWidthPx } : undefined}
          aria-hidden={actionsHidden ? 'true' : undefined}
        >
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
